import produce from 'immer';

const INITIAL_STATE = {
  token: null,
  signed: 0,
  loading: 0,
};

export default function auth(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case '@auth/SIGN_IN_REQUEST': {
        draft.loading = 1;
        break;
      }
      case '@auth/SIGN_IN_SUCCESS': {
        draft.token = action.payload.token;
        draft.signed = 1;
        draft.loading = 0;
        break;
      }
      case '@auth/SIGN_IN_FAILURE': {
        draft.loading = 0;
        break;
      }
      case '@auth/SIGN_UP_REQUEST': {
        draft.loading = 1;
        break;
      }
      case '@auth/SIGN_UP_SUCCESS': {
        draft.loading = 0;
        break;
      }
      case '@auth/SIGN_UP_FAILURE': {
        draft.loading = 0;
        break;
      }
      case '@auth/SIGN_OUT': {
        draft.token = null;
        draft.signed = 0;
        break;
      }
      default:
    }
  });
}
